import { render, staticRenderFns } from "./SessionExpired.vue?vue&type=template&id=b2e82d3e&"
import script from "./SessionExpired.vue?vue&type=script&lang=js&"
export * from "./SessionExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports